document.addEventListener('DOMContentLoaded', function(){

	/* Consts
	==================================== */
	const b = $('body'),
			loader = $('#loader'),
			isTouchDevice = () => {
				return (('ontouchstart' in window) ||
						 (navigator.maxTouchPoints > 0) ||
						 (navigator.msMaxTouchPoints > 0));
			};

	/* Easing
	==================================== */
	const speed   = 200,
			speedx2 = 400,
			ease    = 'easeInOutQuint';

	/* VHeight
	==================================== */
	function height(){
		document.documentElement.style.cssText = `
			--h:  ${window.innerHeight}px;
		`;
	}
	height()

	/* Slider
	==================================== */
	const s = $('.slider-track');
	function pauseVideos(){
		if($('.slide video').length && b.hasClass('template-article')){
			$('.slide:not(:first-child) video').each(function(){
				$(this)[0].pause();
			});
		}
	}
	function playVideos(target){
		if($('.slide video').length && b.hasClass('template-article')){
			if(target.children().is('video')){
				target.children()[0].play();
			}
		}
	}
	function nextSlide(){
		if(s.length){
			var slider = true;
			if(b.hasClass('template-product') && window.innerWidth > 834){
				slider = false;
			}
			if(slider == true && !s.hasClass('transition')){
				if(b.hasClass('lightbox-active')){
					b.removeClass('lightbox-active');
				}
				var target = s.find('.slide:first-child').next();
				playVideos(target)
				s.addClass('transition')
				 .animate({
					'left': '-100%'
				}, speedx2, ease, function(){
					s.append(s.find('.slide:first-child'))
					 .css('left', '0')
					 .removeClass('transition');
					pauseVideos()
				});
			}
		}
	}
	function prevSlide(){
		if(s.length){
			var slider = true;
			if(b.hasClass('template-product') && window.innerWidth > 834){
				slider = false;
			}
			if(slider == true && !s.hasClass('transition')){
				var target = s.find('.slide:last-child')
				if(b.hasClass('lightbox-active')){
					b.removeClass('lightbox-active');
				}
				playVideos(target)
				s.addClass('transition')
				 .prepend(target)
				 .css('left', '-100%').animate({
						'left': '0'
				}, speedx2, ease, function(){
					s.removeClass('transition');
					pauseVideos()
				});
			}
		}
	}
	function checkKey(e){
		e = e || window.event;
		if(e.keyCode == '37' && s.length){
			prevSlide()
		}else if(e.keyCode == '39' && s.length){
			nextSlide()
		}
	}

	/* Scroll Function
	==================================== */
	if('scrollRestoration' in history){
		history.scrollRestoration = 'manual';
	}
	window.scrollTo(0,0);

	/* Device detection
	==================================== */
	if(/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent || navigator.vendor || window.opera) || isTouchDevice() == true){
		//If device
		b.addClass('mobile');
		//Pseudoclass :active on devices
		document.addEventListener('touchstart', function(){}, {passive: true});
		//Resize Functions
		window.addEventListener('orientationchange', function(){
			setTimeout(function(){
				height()
			}, 50);
		});
		//Slider
		if(s.length){
			let tsX = 0,
				 teX = 0;
			$('.slider').bind('touchstart', function(event){
				tsX = event.changedTouches[0].screenX;
			}).bind('touchend', function(event){
				teX = event.changedTouches[0].screenX;
				if(teX <= tsX && (tsX - teX > 50)){
					nextSlide()
				}
				if(teX >= tsX && (teX - tsX > 50)){
					prevSlide()
				}
			})
		}
	}else{
		//if Desktop
		b.addClass('desktop');
		//Resize Functions
		window.onresize = function(){
			height()
		}
		//Slider
		document.onkeydown = checkKey;

		/* Lightbox
		==================================== */
		const gallery = $('#product-gallery');
		gallery.find('.thumb').click(function(){
			var t = $(this);
            b.toggleClass('lightbox-active')
			if(b.hasClass('lightbox-active')){
				gallery.scrollTop(
                  gallery.scrollTop() + t.position().top + t.height()/2 - window.innerHeight/2
				);
			}else{
                $('html, body').animate({
                  scrollTop: t.position().top
                }, 0);    
			}
		});

		/* Screensaver
		==================================== */
		if(loader.attr('screensaver') == 'true'){
			var moving,
				 moveTimer,
				 timer = function(){
					moving = setTimeout(function(){
						if(window.innerWidth > 600){
							loader.fadeIn(speedx2, function(){
								loader.addClass('visible')
							})
						}
					}, loader.data('time')*1000)
					// }, 2000)
				}
			$(window).on('mousemove mouseout click', function(e){
				if(loader.hasClass('loaded')){
					clearTimeout(moving);
					clearTimeout(moveTimer);
					moveTimer = setTimeout(function(){
						timer()
					}, 1000)
					if(loader.hasClass('visible')){
						loader.fadeOut(speedx2, function(){
							loader.removeClass('visible')
						})
					}
				}
			})
		}

	}

	/* Loader
	==================================== */
	if(sessionStorage.getItem('intro') != 'false'){
		setTimeout(function(){
			loader.find('svg').fadeIn(speedx2, function(){
				setTimeout(function(){
					loader.fadeOut(speedx2, function(){
						loader.addClass('loaded')
						sessionStorage.setItem('intro', false);
						if(loader.attr('screensaver') == 'true' && b.hasClass('desktop')){
							timer()
						}
					});
				}, 1600);
			})
		}, 600);
	}else{
		setTimeout(function(){
			loader.fadeOut(speedx2, function(){
				loader.addClass('loaded')
				if(loader.attr('screensaver') == 'true' && b.hasClass('desktop')){
					timer()
				}
			});
		}, speedx2);
	}

	/* Cleaning
	==================================== */
	if($('.clear').length){
		$('.clear').html(function(i, html){
			return html.replace(/&nbsp;/g, ' ');
		});
		$('.clear *:not(.exclude):not(br)').each(function(){
			$(this).filter(function(){
				return $(this).text().trim().length == 0;
			}).remove();
		});
	}

	/* Sections
	==================================== */
	$('.trigger').click(function(){
		var t = $(this),
			 n = t.next('.collapsed');
		if(n.length){
			if($('.collapsed').not(n).is(':visible')){
				$('.collapsed:visible').slideUp(speedx2, ease, function(){
					$('.trigger').removeClass('active')
					t.addClass('active')
					n.slideDown(speed, ease);
				});
			}else{
				t.toggleClass('active')
				n.slideToggle(speed, ease);
			}
		}
	});

	/* Menu
	==================================== */
	$('#menu-trigger').click(function(){
		if(window.innerWidth < 835){
			$('html').toggleClass('pop-up-open')
			$(this).text(function(i, text){
				return text === 'MENU' ? 'CLOSE' : 'MENU';
			})
			$('menu').toggle(0)
		}
	})

	/* Slider
	==================================== */
	$('.next').click(function(){
		nextSlide();
	});
	$('.prev').click(function(){
		prevSlide();
	});

	/* Cart quantity
	==================================== */
	$('.item-quantity select').each(function(){
		$(this).change(function(e){
			e.preventDefault();
			setTimeout(function(){
				$('#update-cart').click();
			}, 20);
		});
	});

	/* Lazy Loading
	==================================== */
	function lazy(t){
		if(t.tagName == 'IMG'){
			t.src = t.dataset.src;
		}
		if(t.tagName == 'VIDEO'){
			var P = t.play();
			if(P !== undefined){
				P.catch(error => {
					if($(t).hasClass('gif')){
						t.classList.add('no-autoplay');
					}else{
						t.classList.add('controls');
						t.controls = true;
					}
				});
			}
		}
		t.classList.remove('lazy');
	}
	var L = [].slice.call(document.querySelectorAll('.lazy'));
	if('IntersectionObserver' in window){
		let o = new IntersectionObserver(function(E, observer){
			E.forEach(function(e){
				if(e.isIntersecting){
					let t = e.target;
					lazy(t)
					o.unobserve(t);
				}
			});
		});
		L.forEach(function(t){
			o.observe(t);
		});
	}else{
		// Not supported, load all images immediately
		L.forEach(function(t){
			lazy(t)
		});
	}

});
